export default __webpack_public_path__ + "static/media/v1.401a4fca.mp4";